export enum Environments {
  'Production' = 'Production',
  'PreProduction' = 'PreProduction',
  'UAT' = 'UAT',
  'SVT' = 'SVT',
  'QA' = 'QA',
  'Mock' = 'Mock',
  'Development' = 'Development',
  'Local' = 'Local',
}

type EnsureValuesAreSameAsKeys<TEnum> = {
  [key in keyof TEnum]: key
}

export type Environment = keyof EnsureValuesAreSameAsKeys<typeof Environments>
